import { useAuthStore } from '@/store/authStore';
import type { DonationUser } from '../components/CardDonationPost/CardDonationPost';
import { AUTHOR_FALLBACK } from '../utils/bookRequest';

/** The signed-in user as shown beside the post and reply composer. */
export const useComposerUser = (): DonationUser => {
  const name = useAuthStore((state) => state.name);
  const pictureUrl = useAuthStore((state) => state.picture_url);
  return { name: name || AUTHOR_FALLBACK, avatar: pictureUrl || undefined };
};
